import { isNil } from 'lodash';
import { isDevelopment } from 'utils/isDevelopment';

export const parseDropDataFromDragEvent = <T extends object>(event: DragEvent): Partial<T> | null => {
  const data = event.dataTransfer?.getData('text/plain');
  if (!data) {
    return null;
  }
  try {
    const parsed = JSON.parse(data);
    if (isNil(parsed)) {
      return null;
    }
    if (typeof parsed !== 'object') {
      return null;
    }

    return parsed as Partial<T>;

  } catch (error) {
    if (isDevelopment()) {
      // eslint-disable-next-line no-console
      console.warn(error);
    }

    return null;
  }
};
